import { atom } from "recoil";

export const workforceListTableDataState = atom({
  key: "workforceListTableDataState",
  default: [],
});

export const workforceListHasMoreDataState = atom({
  key: "workforceListHasMoreDataState",
  default: true,
});

export const workforceListSearchQuery = atom({
  key: "workforceListSearchQuery",
  default: "",
});

export const workforceListPageState = atom({
  key: "workforceListPageState",
  default: 2,
});

export const workforceListTotalCount = atom({
  key: "workforceListTotalCount",
  default: 0,
});

